<template>
    <div>
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">

                    <h2 class="page-header-title">
                        <router-link to="/fire-stopping-reports">
                        Fire Stopping Reports</router-link>
                        &raquo;
                        <router-link :to="{ name: 'fire-stopping-report-view', params: {action: 'view', id: fireStoppingReport.site_fire_stopping_report_id} }">
                            {{ fireStoppingReport.job_number }} | {{ fireStoppingReport.prepared_for }}
                        </router-link>
                        &raquo;
                        <span v-if="isEdit">Edit</span><span v-else>Add</span> Issue</h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">
                    <input
                            name="site_fire_stopping_report_id"
                            type="hidden"
                            v-model="issue.site_fire_stopping_report_id"
                    >
                    <input
                            name="site_fire_stopping_report_item_id"
                            type="hidden"
                            v-model="issue.site_fire_stopping_report_item_id"
                    >
                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Issue Location</h2>
                                </div>
                                <div class="widget-body">
                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('site_fire_stopping_report_site_plan_id')]"
                                                for="site_fire_stopping_report_site_plan_id">
                                            Site Plan
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="site_fire_stopping_report_site_plan_id"
                                                    id="site_fire_stopping_report_site_plan_id"
                                                    :class="['form-control', getFieldClasses('site_fire_stopping_report_site_plan_id')]"
                                                    v-model="issue.site_fire_stopping_report_site_plan_id"
                                                    @blur="onFieldBlur('site_fire_stopping_report_site_plan_id')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="sitePlan.site_fire_stopping_report_site_plan_id" v-for="sitePlan in sitePlans" v-bind:key="sitePlan.site_fire_stopping_report_site_plan_id">{{ sitePlan.site_plan_title }}</option>
                                            </select>
                                            <div v-if="isErrorField('site_fire_stopping_report_site_plan_id')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
            
                                    <div class="form-group" v-if="selectedSitePlanImg">
                                        <site-plan-marker
                                            v-bind:markerPosition="sitePlanMarkerData"
                                            v-bind:markerNumber="issue.pin_number"
                                            v-bind:imgData="selectedSitePlanImg"
                                            @update-marker="updateMarker"
                                            ref="sitePlanComp"
                                        ></site-plan-marker>
                                    </div>
                                    <div v-if="isErrorField('site_plan_image_position_x')" class="invalid-feedback">Please place marker on the site plan</div>
                                </div>
                            </div>

                            <div class="widget has-shadow" v-if="issue.site_plan_image_position_x && issue.site_plan_image_position_y">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Issue Details</h2>
                                </div>
                                <div class="widget-body">

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('issue_location')]"
                                                for="issue_location">
                                            Location
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="issue_location"
                                                    id="issue_location"
                                                    :class="['form-control', getFieldClasses('issue_location')]"
                                                    v-model="issue.issue_location"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('issue_location')"
                                            />
                                            <div v-if="isErrorField('issue_location')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('operative_name')]"
                                                for="operative_name">
                                            Operative
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="operative_name"
                                                    id="operative_name"
                                                    :class="['form-control', getFieldClasses('operative_name')]"
                                                    v-model="issue.operative_name"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('operative_name')"
                                            />
                                            <div v-if="isErrorField('operative_name')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('issue_status')]"
                                                for="issue_status">
                                            Status
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="issue_status"
                                                    id="issue_status"
                                                    :class="['form-control', getFieldClasses('issue_status')]"
                                                    v-model="issue.issue_status"
                                                    @blur="onFieldBlur('issue_status')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="status" v-for="status in issueStatuses" v-bind:key="status">{{ status }}</option>
                                            </select>
                                            <div v-if="isErrorField('issue_status')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('required_fire_rating')]"
                                                for="required_fire_rating">
                                            Required Fire Rating
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="required_fire_rating"
                                                    id="required_fire_rating"
                                                    :class="['form-control', getFieldClasses('required_fire_rating')]"
                                                    v-model="issue.required_fire_rating"
                                                    @blur="onFieldBlur('required_fire_rating')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="fireRating.fsr_required_fire_rating_name" v-for="fireRating in fsrFireRatings" v-bind:key="fireRating.fsr_required_fire_rating_id">{{ fireRating.fsr_required_fire_rating_name }}</option>
                                            </select>
                                            <div v-if="isErrorField('required_fire_rating')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('substrate')]"
                                                for="substrate">
                                            Substrate
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="substrate"
                                                    id="substrate"
                                                    :class="['form-control', getFieldClasses('substrate')]"
                                                    v-model="issue.substrate"
                                                    @blur="onFieldBlur('substrate')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="substrateTypeOption.fsr_substrate_type_name" v-for="substrateTypeOption in fsrSubstrateTypes" v-bind:key="substrateTypeOption.fsr_substrate_type_id">{{ substrateTypeOption.fsr_substrate_type_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('substrate')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="issue.substrate !== null && issue.substrate !== '' && substrateNamesArray.indexOf(issue.substrate) === -1">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="substrate_override">
                                                Specify Substrate
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="substrate_override"
                                                        id="substrate_override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="issue.substrate"
                                                        type="text"
                                                >
                                                <div v-if="isErrorField('substrate')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('construction_type')]"
                                                for="construction_type">
                                            Construction Type
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="construction_type"
                                                    id="construction_type"
                                                    :class="['form-control', getFieldClasses('construction_type')]"
                                                    v-model="issue.construction_type"
                                                    @blur="onFieldBlur('construction_type')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="constructionTypeOption.fsr_construction_type_name" v-for="constructionTypeOption in fsrConstructionTypes" v-bind:key="constructionTypeOption.fsr_construction_type_id">{{ constructionTypeOption.fsr_construction_type_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('construction_type')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="issue.construction_type !== null && issue.construction_type !== '' && constructionTypeNamesArray.indexOf(issue.construction_type) === -1">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="construction_type_override">
                                                Specify Construction Type
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="construction_type_override"
                                                        id="construction_type_override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="issue.construction_type"
                                                        type="text"
                                                >
                                                <div v-if="isErrorField('construction_type')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Services</h2>

                                        <div class="form-group row d-flex align-items-center required">
                                            <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                <label :class="[getContainerClasses('pipes_selected')]">
                                                    Pipes?</label>
                                            </div>
                                            <div class="col-lg-6 col-md-12">
                                                <ul class="radio-as-buttons">
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="true" id="services-pipes-yes"
                                                            name="pipes_selected"
                                                            v-model="issue.pipes_selected"
                                                            class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                        >
                                                        <label for="services-pipes-yes">Yes</label>
                                                    </li>
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="false" id="services-pipes-no"
                                                            name="pipes_selected"
                                                            v-model="issue.pipes_selected"
                                                            class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                        >
                                                        <label for="services-pipes-no">No</label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="issue.pipes_selected">
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('pipes_material')]"
                                                        for="pipes_material">
                                                    Material
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="pipes_material"
                                                            id="pipes_material"
                                                            :class="['form-control', getFieldClasses('pipes_material')]"
                                                            v-model="issue.pipes_material"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('pipes_material')"
                                                    />
                                                    <div v-if="isErrorField('pipes_material')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('pipes_size')]"
                                                        for="pipes_size">
                                                    Size
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="pipes_size"
                                                            id="pipes_size"
                                                            :class="['form-control', getFieldClasses('pipes_size')]"
                                                            v-model="issue.pipes_size"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('pipes_size')"
                                                    />
                                                    <div v-if="isErrorField('pipes_size')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('pipes_thermal_insulation')]"
                                                        for="pipes_thermal_insulation">
                                                    Thermal Insulation
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <select
                                                            name="pipes_thermal_insulation"
                                                            id="pipes_thermal_insulation"
                                                            :class="['form-control', getFieldClasses('pipes_thermal_insulation')]"
                                                            v-model="issue.pipes_thermal_insulation"
                                                            @blur="onFieldBlur('pipes_thermal_insulation')"
                                                    >
                                                        <option value="" disabled="disabled">Please select an option</option>
                                                        <option v-bind:value="thermalInsulationOption.fsr_thermal_insulation_name" v-for="thermalInsulationOption in fsrThermalInsulations" v-bind:key="thermalInsulationOption.fsr_thermal_insulation_id">{{ thermalInsulationOption.fsr_thermal_insulation_name }}</option>
                                                    </select>
                                                    <div v-if="isErrorField('pipes_thermal_insulation')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('pipes_distance_to_first_support')]"
                                                        for="pipes_distance_to_first_support">
                                                    Distance of First Support
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="pipes_distance_to_first_support"
                                                            id="pipes_distance_to_first_support"
                                                            :class="['form-control', getFieldClasses('pipes_distance_to_first_support')]"
                                                            v-model="issue.pipes_distance_to_first_support"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('pipes_distance_to_first_support')"
                                                    />
                                                    <div v-if="isErrorField('pipes_distance_to_first_support')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('pipes_proximity_to_each_other')]"
                                                        for="pipes_proximity_to_each_other">
                                                    Proximity to Each Other
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="pipes_proximity_to_each_other"
                                                            id="pipes_proximity_to_each_other"
                                                            :class="['form-control', getFieldClasses('pipes_proximity_to_each_other')]"
                                                            v-model="issue.pipes_proximity_to_each_other"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('pipes_proximity_to_each_other')"
                                                    />
                                                    <div v-if="isErrorField('pipes_proximity_to_each_other')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center required">
                                            <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                <label :class="[getContainerClasses('cables_selected')]">
                                                    Cables?</label>
                                            </div>
                                            <div class="col-lg-6 col-md-12">
                                                <ul class="radio-as-buttons">
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="true" id="services-cables-yes"
                                                            name="cables_selected"
                                                            v-model="issue.cables_selected"
                                                            class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                        >
                                                        <label for="services-cables-yes">Yes</label>
                                                    </li>
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="false" id="services-cables-no"
                                                            name="cables_selected"
                                                            v-model="issue.cables_selected"
                                                            class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                        >
                                                        <label for="services-cables-no">No</label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="issue.cables_selected">
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('cables_size')]"
                                                        for="cables_size">
                                                    Size
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="cables_size"
                                                            id="cables_size"
                                                            :class="['form-control', getFieldClasses('cables_size')]"
                                                            v-model="issue.cables_size"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('cables_size')"
                                                    />
                                                    <div v-if="isErrorField('cables_size')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                    <label :class="[getContainerClasses('cables_bundles')]">
                                                        Bundles?</label>
                                                </div>
                                                <div class="col-lg-6 col-md-12">
                                                    <ul class="radio-as-buttons">
                                                        <li class="template-option--li">
                                                            <input type="radio" v-bind:value="true" id="services-cables-bundles-yes"
                                                                name="cables_bundles"
                                                                v-model="issue.cables_bundles"
                                                                class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                            >
                                                            <label for="services-cables-bundles-yes">Yes</label>
                                                        </li>
                                                        <li class="template-option--li">
                                                            <input type="radio" v-bind:value="false" id="services-cables-bundles-no"
                                                                name="cables_bundles"
                                                                v-model="issue.cables_bundles"
                                                                class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                            >
                                                            <label for="services-cables-bundles-no">No</label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('cables_trays_type')]"
                                                        for="cables_trays_type">
                                                    Cable Trays Type
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="cables_trays_type"
                                                            id="cables_trays_type"
                                                            :class="['form-control', getFieldClasses('cables_trays_type')]"
                                                            v-model="issue.cables_trays_type"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('cables_trays_type')"
                                                    />
                                                    <div v-if="isErrorField('cables_trays_type')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('cables_trays_size')]"
                                                        for="cables_trays_size">
                                                    Cable Trays Size
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="cables_trays_size"
                                                            id="cables_trays_size"
                                                            :class="['form-control', getFieldClasses('cables_trays_size')]"
                                                            v-model="issue.cables_trays_size"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('cables_trays_size')"
                                                    />
                                                    <div v-if="isErrorField('cables_trays_size')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('cables_support_conditions')]"
                                                        for="cables_support_conditions">
                                                    Support Conditions
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="cables_support_conditions"
                                                            id="cables_support_conditions"
                                                            :class="['form-control', getFieldClasses('cables_support_conditions')]"
                                                            v-model="issue.cables_support_conditions"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('cables_support_conditions')"
                                                    />
                                                    <div v-if="isErrorField('cables_support_conditions')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('cables_distance_to_first_support')]"
                                                        for="cables_distance_to_first_support">
                                                    Distance of First Support
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="cables_distance_to_first_support"
                                                            id="cables_distance_to_first_support"
                                                            :class="['form-control', getFieldClasses('cables_distance_to_first_support')]"
                                                            v-model="issue.cables_distance_to_first_support"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('cables_distance_to_first_support')"
                                                    />
                                                    <div v-if="isErrorField('cables_distance_to_first_support')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('cables_proximity_to_each_other')]"
                                                        for="cables_proximity_to_each_other">
                                                    Proximity to Each Other
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="cables_proximity_to_each_other"
                                                            id="cables_proximity_to_each_other"
                                                            :class="['form-control', getFieldClasses('cables_proximity_to_each_other')]"
                                                            v-model="issue.cables_proximity_to_each_other"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('cables_proximity_to_each_other')"
                                                    />
                                                    <div v-if="isErrorField('cables_proximity_to_each_other')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center required">
                                            <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                <label :class="[getContainerClasses('ducts_selected')]">
                                                    Ducts/Dampers?</label>
                                            </div>
                                            <div class="col-lg-6 col-md-12">
                                                <ul class="radio-as-buttons">
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="true" id="services-ducts-yes"
                                                            name="ducts_selected"
                                                            v-model="issue.ducts_selected"
                                                            class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                        >
                                                        <label for="services-ducts-yes">Yes</label>
                                                    </li>
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="false" id="services-ducts-no"
                                                            name="ducts_selected"
                                                            v-model="issue.ducts_selected"
                                                            class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                        >
                                                        <label for="services-ducts-no">No</label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="issue.ducts_selected">
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('ducts_size')]"
                                                        for="ducts_size">
                                                    Size
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="ducts_size"
                                                            id="ducts_size"
                                                            :class="['form-control', getFieldClasses('ducts_size')]"
                                                            v-model="issue.ducts_size"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('ducts_size')"
                                                    />
                                                    <div v-if="isErrorField('ducts_size')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('ducts_manufacturer')]"
                                                        for="ducts_manufacturer">
                                                    Manufacturer
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="ducts_manufacturer"
                                                            id="ducts_manufacturer"
                                                            :class="['form-control', getFieldClasses('ducts_manufacturer')]"
                                                            v-model="issue.ducts_manufacturer"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('ducts_manufacturer')"
                                                    />
                                                    <div v-if="isErrorField('ducts_manufacturer')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('ducts_seal_details')]"
                                                        for="ducts_seal_details">
                                                    Seal Details
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <select
                                                            name="ducts_seal_details"
                                                            id="ducts_seal_details"
                                                            :class="['form-control', getFieldClasses('ducts_seal_details')]"
                                                            v-model="issue.ducts_seal_details"
                                                            @blur="onFieldBlur('ducts_seal_details')"
                                                    >
                                                        <option value="" disabled="disabled">Please select an option</option>
                                                        <option value=" ">Proprietary</option>
                                                        <option value="Generic">Generic</option>
                                                    </select>
                                                    <div v-if="isErrorField('ducts_seal_details')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div v-if="issue.ducts_seal_details !== null && issue.ducts_seal_details !== 'Generic'">
                                                <div class="form-group row d-flex align-items-center d-none">
                                                    <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="ducts_seal_details_override">
                                                        Specify Seal Details
                                                    </label>
                                                    <div class="col-lg-6 col-md-12">
                                                        <input
                                                                name="ducts_seal_details_override"
                                                                id="ducts_seal_details_override"
                                                                :class="['form-control', { 'has-error': submitting }]"
                                                                v-model="issue.ducts_seal_details"
                                                                type="text"
                                                        >
                                                        <div v-if="isErrorField('ducts_seal_details')" class="invalid-feedback">This field is required</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('ducts_support_conditions')]"
                                                        for="ducts_support_conditions">
                                                    Support Conditions
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="ducts_support_conditions"
                                                            id="ducts_support_conditions"
                                                            :class="['form-control', getFieldClasses('ducts_support_conditions')]"
                                                            v-model="issue.ducts_support_conditions"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('ducts_support_conditions')"
                                                    />
                                                    <div v-if="isErrorField('ducts_support_conditions')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('ducts_distance_to_first_support')]"
                                                        for="ducts_distance_to_first_support">
                                                    Distance of First Support
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="ducts_distance_to_first_support"
                                                            id="ducts_distance_to_first_support"
                                                            :class="['form-control', getFieldClasses('ducts_distance_to_first_support')]"
                                                            v-model="issue.ducts_distance_to_first_support"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('ducts_distance_to_first_support')"
                                                    />
                                                    <div v-if="isErrorField('ducts_distance_to_first_support')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('ducts_proximity_to_each_other')]"
                                                        for="ducts_proximity_to_each_other">
                                                    Proximity to Each Other
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="ducts_proximity_to_each_other"
                                                            id="ducts_proximity_to_each_other"
                                                            :class="['form-control', getFieldClasses('ducts_proximity_to_each_other')]"
                                                            v-model="issue.ducts_proximity_to_each_other"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('ducts_proximity_to_each_other')"
                                                    />
                                                    <div v-if="isErrorField('ducts_proximity_to_each_other')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Opening</h2>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('opening_size')]"
                                                    for="opening_size">
                                                Size
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="opening_size"
                                                        id="opening_size"
                                                        :class="['form-control', getFieldClasses('opening_size')]"
                                                        v-model="issue.opening_size"
                                                        type="text"
                                                        maxlength="255"
                                                        class="form-control"
                                                        @blur="onFieldBlur('opening_size')"
                                                />
                                                <div v-if="isErrorField('opening_size')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('opening_depth')]"
                                                    for="opening_depth">
                                                Depth
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="opening_depth"
                                                        id="opening_depth"
                                                        :class="['form-control', getFieldClasses('opening_depth')]"
                                                        v-model="issue.opening_depth"
                                                        type="text"
                                                        maxlength="255"
                                                        class="form-control"
                                                        @blur="onFieldBlur('opening_depth')"
                                                />
                                                <div v-if="isErrorField('opening_depth')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center required">
                                            <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                <label :class="[getContainerClasses('opening_preparation')]">
                                                    Preparation in Place?</label>
                                            </div>
                                            <div class="col-lg-6 col-md-12">
                                                <ul class="radio-as-buttons">
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="true" id="opening-preparation-yes"
                                                            name="opening_preparation"
                                                            v-model="issue.opening_preparation"
                                                            class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                        >
                                                        <label for="opening-preparation-yes">Yes</label>
                                                    </li>
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="false" id="opening-preparation-no"
                                                            name="opening_preparation"
                                                            v-model="issue.opening_preparation"
                                                            class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                        >
                                                        <label for="opening-preparation-no">No</label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="issue.opening_preparation">
                                            <div class="form-group row d-flex align-items-center ">
                                                <label
                                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('opening_preparation_details')]"
                                                        for="opening_preparation_details">
                                                    Details
                                                </label>
                                                <div class="col-lg-6 col-md-12">
                                                    <input
                                                            name="opening_preparation_details"
                                                            id="opening_preparation_details"
                                                            :class="['form-control', getFieldClasses('opening_preparation_details')]"
                                                            v-model="issue.opening_preparation_details"
                                                            type="text"
                                                            maxlength="255"
                                                            class="form-control"
                                                            @blur="onFieldBlur('opening_preparation_details')"
                                                    />
                                                    <div v-if="isErrorField('opening_preparation_details')" class="invalid-feedback">This field is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group row d-flex align-items-center required">
                                                <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                    <label :class="[getContainerClasses('opening_preparation_adequate')]">
                                                        Adequate?</label>
                                                </div>
                                                <div class="col-lg-6 col-md-12">
                                                    <ul class="radio-as-buttons">
                                                        <li class="template-option--li">
                                                            <input type="radio" v-bind:value="true" id="opening-preparation-adequate-yes"
                                                                name="opening_preparation_adequate"
                                                                v-model="issue.opening_preparation_adequate"
                                                                class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                            >
                                                            <label for="opening-preparation-adequate-yes">Yes</label>
                                                        </li>
                                                        <li class="template-option--li">
                                                            <input type="radio" v-bind:value="false" id="opening-preparation-adequate-no"
                                                                name="opening_preparation_adequate"
                                                                v-model="issue.opening_preparation_adequate"
                                                                class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                            >
                                                            <label for="opening-preparation-adequate-no">No</label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', 'text-right', getContainerClasses('opening_proximity_to_other_elements')]"
                                                    for="opening_proximity_to_other_elements">
                                                Proximity to Other Elements (including walls and floors)
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="opening_proximity_to_other_elements"
                                                        id="opening_proximity_to_other_elements"
                                                        :class="['form-control', getFieldClasses('opening_proximity_to_other_elements')]"
                                                        v-model="issue.opening_proximity_to_other_elements"
                                                        type="text"
                                                        maxlength="255"
                                                        class="form-control"
                                                        @blur="onFieldBlur('opening_proximity_to_other_elements')"
                                                />
                                                <div v-if="isErrorField('opening_proximity_to_other_elements')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center required">
                                            <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                <label :class="[getContainerClasses('opening_space_adequate')]">
                                                    Space Adequate?</label>
                                            </div>
                                            <div class="col-lg-6 col-md-12">
                                                <ul class="radio-as-buttons">
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="true" id="opening-space-adequate-yes"
                                                            name="opening_space_adequate"
                                                            v-model="issue.opening_space_adequate"
                                                            class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                        >
                                                        <label for="opening-space-adequate-yes">Yes</label>
                                                    </li>
                                                    <li class="template-option--li">
                                                        <input type="radio" v-bind:value="false" id="opening-space-adequate-no"
                                                            name="opening_space_adequate"
                                                            v-model="issue.opening_space_adequate"
                                                            class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                        >
                                                        <label for="opening-space-adequate-no">No</label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Work Required</h2>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                            class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                            for="work_required">Details</label>
                                            <div class="col-lg-6 col-md-12">
                                                <textarea class="form-control"
                                                    v-model="issue.work_required"
                                                    name="work_required"
                                                    maxlength="2000"
                                                    id="work_required"
                                                    rows="5"></textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center " v-if="fsrFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="frame-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="issue.fire_stopping_report_item_faults"
                                                        :options="fsrFaults"
                                                        label="fault_description"
                                                        track-by="fsr_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="issue.fire_stopping_report_item_faults && issue.fire_stopping_report_item_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in issue.fire_stopping_report_item_faults" :key="'fault'+faultItem.fsr_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                        :for="'qty_'+ faultItem.fsr_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                :id="'qty_'+ faultItem.fsr_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end text-right">
                                                Photos Before Installation
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div v-for="offlineImage in preInstallationImages" style="margin-bottom: 10px;">
                                                    <img v-bind:src="offlineImage.data" class="img-fluid">
                                                </div>
                                                <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                    <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                        Adding image... Please wait...</h3>
                                                </div>
                                                <label class="fileContainer">
                                                    <span class="fa fa-camera"></span> Click to add an image
                                                    <input type="file" accept="image/*" capture="camera" @change="onFileChange($event, true)">
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group border-top" v-if="issue.issue_status !== null && issue.issue_status !== issueStatuses[0]">
                                        <h2 class="mt-4">Installation</h2>

                                        <div class="form-group row d-flex align-items-center">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                    for="installation_date">
                                                Installation Date
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <datepicker
                                                        v-model="issue.installation_date"
                                                        format="dd/MM/yy"
                                                        input-class="form-control"
                                                        name="installation_date"
                                                ></datepicker>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('installed_by')]"
                                                    for="installed_by">
                                                Installed By
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="installed_by"
                                                        id="installed_by"
                                                        :class="['form-control', getFieldClasses('installed_by')]"
                                                        v-model="issue.installed_by"
                                                        type="text"
                                                        maxlength="255"
                                                        class="form-control"
                                                        @blur="onFieldBlur('installed_by')"
                                                />
                                                <div v-if="isErrorField('installed_by')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center " v-if="fsrProducts.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="fsr-products">Products Installed</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="issue.fsr_products"
                                                        :options="fsrProducts"
                                                        label="product_name"
                                                        track-by="fsr_product_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>

                                        <div class="form-group row align-items-center d-flex">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                Installer's Signature
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div class="signature-area" v-if="issue.offline_engineer_signature_image != null">
                                                    <img v-bind:src="issue.offline_engineer_signature_image.data" class="img-fluid">
                                                </div>
                                                <div v-else-if="issue.engineer_signature_image != null">
                                                    Signature uploaded
                                                </div>
                                                <div class="pt-2">
                                                    <div v-if="addingEngineerSignature">
                                                        <div class="signature-area">
                                                            <VueSignaturePad width="100%" height="200px" ref="engineerSignaturePad" />
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="saveEngineerSignature">Save signature</a>
                                                            </div>
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="clearEngineerSignature">Clear signature</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                        href="javascript:void(0)"
                                                        v-on:click="addEditEngineerSignature"
                                                    ><span v-if="issue.offline_engineer_signature_image != null || issue.engineer_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center " v-if="fsrMaterials.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="fsr-materials-faults">Materials Used</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="issue.fsr_materials"
                                                        :options="fsrMaterials"
                                                        label="material_name"
                                                        track-by="fsr_material_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end text-right">
                                                Photos After Installation
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div v-for="offlineImage in postInstallationImages" style="margin-bottom: 10px;">
                                                    <img v-bind:src="offlineImage.data" class="img-fluid">
                                                </div>
                                                <div v-if="isPostImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                    <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                        Adding image... Please wait...</h3>
                                                </div>
                                                <label class="fileContainer">
                                                    <span class="fa fa-camera"></span> Click to add an image
                                                    <input type="file" accept="image/*" capture="camera" @change="onFileChange($event, false)">
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="form-group border-top" v-if="issue.issue_status === issueStatuses[2]">
                                        <h2 class="mt-4">Audit</h2>

                                        <div class="form-group row d-flex align-items-center">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                    for="audit_date">
                                                Audit Date
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <datepicker
                                                        v-model="issue.audit_date"
                                                        format="dd/MM/yy"
                                                        input-class="form-control"
                                                        name="audit_date"
                                                ></datepicker>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('audited_by')]"
                                                    for="audited_by">
                                                Audit By
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="audited_by"
                                                        id="audited_by"
                                                        :class="['form-control', getFieldClasses('audited_by')]"
                                                        v-model="issue.audited_by"
                                                        type="text"
                                                        maxlength="255"
                                                        class="form-control"
                                                        @blur="onFieldBlur('audited_by')"
                                                />
                                                <div v-if="isErrorField('audited_by')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="audit_comments">
                                                Comments
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <textarea class="form-control"
                                                    v-model="issue.audit_comments"
                                                    name="audit_comments"
                                                    maxlength="2000"
                                                    id="audit_comments"
                                                    rows="5"></textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row align-items-center d-flex">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                Sign-off Signature
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div class="signature-area" v-if="issue.offline_sign_off_signature_image != null">
                                                    <img v-bind:src="issue.offline_sign_off_signature_image.data" class="img-fluid">
                                                </div>
                                                <div v-else-if="issue.sign_off_signature_image != null">
                                                    Signature uploaded
                                                </div>
                                                <div class="pt-2">
                                                    <div v-if="addingSignOffSignature">
                                                        <div class="signature-area">
                                                            <VueSignaturePad width="100%" height="200px" ref="signOffSignaturePad" />
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="saveSignOffSignature">Save signature</a>
                                                            </div>
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="clearSignOffSignature">Clear signature</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                        href="javascript:void(0)"
                                                        v-on:click="addEditSignOffSignature"
                                                    ><span v-if="issue.offline_sign_off_signature_image != null || issue.sign_off_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                    

                                    

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>


                            





                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>



    </div>
</template>


<script>
    import SitePlanMarker from '../components/SitePlanMarker.vue';
    import { required } from 'vuelidate/lib/validators';
    import ImageRotate from '@/components/mixins/ImageRotate.js';
    import Datepicker from 'vuejs-datepicker';
    import Multiselect from 'vue-multiselect'
    import moment from 'moment';

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    export default {
        mixins: [ImageRotate],
        data() {
            return {
                isEdit: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                addingEngineerSignature: false,
                addingSignOffSignature: false,
                isImageUploading: false,
                isPostImageUploading: false,
                issue: {
                    fire_stopping_report_item_id: null,
                    site_fire_stopping_report_item_id: Math.floor(new Date().getTime() / 1000),
                    site_fire_stopping_report_id: null,
                    fire_stopping_report_id: null,
                    site_fire_stopping_report_site_plan_id: null,
                    fire_stopping_report_site_plan_id: null,
                    site_plan_image_position_x: null,
                    site_plan_image_position_y: null,
                    site_plan_image_zoom_level: null,
                    pin_number: null,
                    issue_reference: null,
                    issue_location: null,
                    operative_name: null,
                    issue_status: null,
                    required_fire_rating: null,
                    substrate: null,
                    construction_type: null,
                    pipes_selected: false,
                    pipes_material: null,
                    pipes_size: null,
                    pipes_thermal_insulation: null,
                    pipes_distance_to_first_support: null,
                    pipes_proximity_to_each_other: null,
                    cables_selected: false,
                    cables_size: null,
                    cables_bundles: false,
                    cables_trays_type: null,
                    cables_trays_size: null,
                    cables_support_conditions: null,
                    cables_distance_to_first_support: null,
                    cables_proximity_to_each_other: null,
                    ducts_selected: false,
                    ducts_size: null,
                    ducts_manufacturer: null,
                    ducts_seal_details: null,
                    ducts_support_conditions: null,
                    ducts_distance_to_first_support: null,
                    ducts_proximity_to_each_other: null,
                    opening_size: null,
                    opening_depth: null,
                    opening_preparation: false,
                    opening_preparation_details: null,
                    opening_preparation_adequate: false,
                    opening_proximity_to_other_elements: null,
                    opening_space_adequate: false,
                    work_required: null,
                    installation_date: null,
                    installed_by: null,
                    engineer_signature_image: null,
                    audit_date: null,
                    audit_comments: null,
                    audited_by: null,
                    sign_off_signature_image: null,
                    fsr_materials: null,
                    fsr_products: null,
                    fire_stopping_report_item_faults: null,
                    fire_stopping_report_item_images: null,
                    user: null,
                    offline_images: [],
                    offline_engineer_signature_image: null,
                    offline_sign_off_signature_image: null
                },
                fireStoppingReport: {
                    fire_stopping_report_id: null,
                    job_number: 'Loading...',
                    prepared_for: 'Please wait...',
                    site_fire_stopping_report_id: this.isEdit ? null : this.$route.params.id,
                },
                sitePlans: [],
                fsrFaults: [],
                fsrMaterials: [],
                fsrProducts: [],
                fsrFireRatings: [],
                fsrSubstrateTypes: [],
                fsrConstructionTypes: [],
                fsrThermalInsulations: [],
                issueStatuses: ['Surveyed', 'Installed', 'Audited'],
            }
        },
        validations: {
            issue: {
                issue_location: { required },
                issue_status: { required },
                site_fire_stopping_report_site_plan_id: { required },
                required_fire_rating: { required },
                substrate: { required },
                construction_type: { required }
            },
        },
        components: {
            SitePlanMarker,
            Datepicker,
            Multiselect
        },
        methods: {
            onFileChange(e, isPreInstallationImg) {
                if(isPreInstallationImg) {
                    this.isPostImageUploading = true;
                } else {
                    this.isImageUploading = true;
                }
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    if(isPreInstallationImg) {
                        this.isPostImageUploading = false;
                    } else {
                        this.isImageUploading = false;
                    }
                    return;
                }
                var vm = this;
                EXIF.getData(files[0], function() {
                    var orientation = EXIF.getTag(this, "Orientation");
                    vm.createImage(files[0], orientation, isPreInstallationImg);
                });
            },
            createImage(file, orientation, isPreInstallationImg) {
                var compress = new Compress()
                var files = [file]

                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then(async (data) => {
                    var imgSrc = data[0].prefix + data[0].data;
                    var rotationDegrees = 0;
                    switch(orientation) {
                        case 3:
                            rotationDegrees = 180;
                            break;
                        case 6:
                            rotationDegrees = -90;
                            break;
                        case 8:
                            rotationDegrees = 90;
                            break;    
                    }

                    if(rotationDegrees != 0) {
                        await this.rotateImage(imgSrc, rotationDegrees).then(newDataUri => {
                            console.log('Image rotated');
                            imgSrc = newDataUri;
                        }).catch(e => {
                            console.log(e);
                        });
                    }

                    console.log('Image added to array');
                    this.issue.offline_images.push({
                        'data': imgSrc, 
                        'alt': data[0].alt, 
                        'orientation': orientation, 
                        'offline_image_id': this.$session.get('user_id').toString() + Math.floor(new Date().getTime() / 1000),
                        'is_pre_installation_img': isPreInstallationImg
                    });
                    if(isPreInstallationImg) {
                        this.isPostImageUploading = false;
                    } else {
                        this.isImageUploading = false;
                    }
                });
            },
            clearEngineerSignature() {
                this.$refs.engineerSignaturePad.clearSignature();
            },
            saveEngineerSignature() {
                const { isEmpty, data } = this.$refs.engineerSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.issue.offline_engineer_signature_image = {
                        data: data
                    };
                }
                
                this.addingEngineerSignature = false;
                this.clearEngineerSignature();
            },
            addEditEngineerSignature() {
                this.addingEngineerSignature = true;
            },
            clearSignOffSignature() {
                this.$refs.signOffSignaturePad.clearSignature();
            },
            saveSignOffSignature() {
                const { isEmpty, data } = this.$refs.signOffSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.issue.offline_sign_off_signature_image = {
                        data: data
                    };
                }
                
                this.addingSignOffSignature = false;
                this.clearSignOffSignature();
            },
            addEditSignOffSignature() {
                this.addingSignOffSignature = true;
            },
            getFireRatings() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.fsrFireRatings = [];
                    try {
                        var objectStore = db.transaction('fsr_required_fire_ratings').objectStore('fsr_required_fire_ratings');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.fsrFireRatings) {
                                        vmt.fsrFireRatings.push({
                                            fsr_required_fire_rating_id: cursor.value.fsr_required_fire_rating_id,
                                            fsr_required_fire_rating_name: cursor.value.fsr_required_fire_rating_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getSubstrateTypes() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.fsrSubstrateTypes = [];
                    try {
                        var objectStore = db.transaction('fsr_substrate_types').objectStore('fsr_substrate_types');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.fsrSubstrateTypes) {
                                        vmt.fsrSubstrateTypes.push({
                                            fsr_substrate_type_id: cursor.value.fsr_substrate_type_id,
                                            fsr_substrate_type_name: cursor.value.fsr_substrate_type_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getConstructionTypes() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.fsrConstructionTypes = [];
                    try {
                        var objectStore = db.transaction('fsr_construction_types').objectStore('fsr_construction_types');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.fsrConstructionTypes) {
                                        vmt.fsrConstructionTypes.push({
                                            fsr_construction_type_id: cursor.value.fsr_construction_type_id,
                                            fsr_construction_type_name: cursor.value.fsr_construction_type_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getThermalInsulations() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.fsrThermalInsulations = [];
                    try {
                        var objectStore = db.transaction('fsr_thermal_insulations').objectStore('fsr_thermal_insulations');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.fsrThermalInsulations) {
                                        vmt.fsrThermalInsulations.push({
                                            fsr_thermal_insulation_id: cursor.value.fsr_thermal_insulation_id,
                                            fsr_thermal_insulation_name: cursor.value.fsr_thermal_insulation_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getFsrFaults() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.fsrFaults = [];
                    try {
                        var objectStore = db.transaction('fsr_faults').objectStore('fsr_faults');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.fsrFaults) {
                                        vmt.fsrFaults.push({
                                            fsr_fault_id: cursor.value.fsr_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getFsrMaterials() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.fsrMaterials = [];
                    try {
                        var objectStore = db.transaction('fsr_materials').objectStore('fsr_materials');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.fsrMaterials) {
                                        vmt.fsrMaterials.push({
                                            fsr_material_id: cursor.value.fsr_material_id,
                                            material_name: cursor.value.material_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getFsrProducts() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.fsrProducts = [];
                    try {
                        var objectStore = db.transaction('fsr_products').objectStore('fsr_products');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.fsrProducts) {
                                        vmt.fsrProducts.push({
                                            fsr_product_id: cursor.value.fsr_product_id,
                                            product_name: cursor.value.product_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            generateMarkerNumber() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var objectStore = db.transaction('fire_stopping_report_items').objectStore('fire_stopping_report_items');
                        if (objectStore) {
                            var highestMarkerNumber = null;
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if(
                                        cursor.value.site_fire_stopping_report_id == vm.fireStoppingReport.site_fire_stopping_report_id && 
                                        cursor.value.pin_number &&
                                        (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined) &&
                                        (!highestMarkerNumber || highestMarkerNumber < cursor.value.pin_number)
                                    ) {
                                        highestMarkerNumber = cursor.value.pin_number;
                                    }
                                    cursor.continue();
                                } else if(!highestMarkerNumber) {
                                    vm.issue.pin_number = 1;
                                } else {
                                    vm.issue.pin_number = highestMarkerNumber + 1;
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getIssue() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var itemId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_report_items').objectStore('fire_stopping_report_items');
                        var storeRequest = objectStore.get(itemId);
                        storeRequest.onsuccess = function(event) {
                            if(storeRequest.result.offline_sign_off_signature_image === undefined) {
                                storeRequest.result.offline_sign_off_signature_image = null;
                            }
                            if(storeRequest.result.sign_off_signature_image === undefined) {
                                storeRequest.result.sign_off_signature_image = null;
                            }
                            vm.issue = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.getFireStoppingReport(false);
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getFireStoppingReport(generateMarkerNo) {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var reportId = vm.isEdit ? vm.issue.site_fire_stopping_report_id : parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_reports').objectStore('fire_stopping_reports');
                        var storeRequest = objectStore.get(reportId);
                        storeRequest.onsuccess = function(event) {
                            vm.fireStoppingReport = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                //console.log(vm.fireStoppingReport);
                                vm.issue.site_fire_stopping_report_id = vm.fireStoppingReport.site_fire_stopping_report_id;
                                vm.issue.fire_stopping_report_id = vm.fireStoppingReport.fire_stopping_report_id;
                                if(generateMarkerNo) {
                                    vm.generateMarkerNumber();
                                }
                                vm.getSitePlans();
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getSitePlans() {
                var vm = this;
                vm.sitePlans = [];
                this.getDb(function onConnectedDb(db) {
                    try {
                        var objectStore = db.transaction('fire_stopping_report_site_plans').objectStore('fire_stopping_report_site_plans');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if(
                                        cursor.value.site_fire_stopping_report_id == vm.fireStoppingReport.site_fire_stopping_report_id && 
                                        (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)
                                    ) {
                                        vm.sitePlans.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                const zoomLevel = this.$refs.sitePlanComp.getZoomLevel();

                var vmt = this;
                this.getDb(function onConnectedDb(db) {

                    var putRequest = db.transaction('fire_stopping_report_items', 'readwrite')
                        .objectStore('fire_stopping_report_items').put({
                            fire_stopping_report_item_id: vmt.issue['fire_stopping_report_item_id'],
                            site_fire_stopping_report_item_id: parseInt(vmt.issue['site_fire_stopping_report_item_id']),
                            site_fire_stopping_report_id: parseInt(vmt.issue['site_fire_stopping_report_id']),
                            fire_stopping_report_id: vmt.issue['fire_stopping_report_id'],
                            site_fire_stopping_report_site_plan_id: parseInt(vmt.issue['site_fire_stopping_report_site_plan_id']),
                            fire_stopping_report_site_plan_id: vmt.issue['fire_stopping_report_site_plan_id'],
                            site_plan_image_position_x: vmt.issue['site_plan_image_position_x'],
                            site_plan_image_position_y: vmt.issue['site_plan_image_position_y'],
                            site_plan_image_zoom_level: zoomLevel,
                            pin_number: vmt.issue['pin_number'],
                            issue_reference: vmt.issue['issue_reference'],
                            issue_location: vmt.issue['issue_location'],
                            operative_name: vmt.issue['operative_name'] !== undefined ? vmt.issue['operative_name'] : null,
                            issue_status: vmt.issue['issue_status'],
                            required_fire_rating: vmt.issue['required_fire_rating'],
                            substrate: vmt.issue['substrate'],
                            construction_type: vmt.issue['construction_type'],
                            pipes_selected: vmt.issue['pipes_selected'],
                            pipes_material: vmt.issue['pipes_material'],
                            pipes_size: vmt.issue['pipes_size'],
                            pipes_thermal_insulation: vmt.issue['pipes_thermal_insulation'],
                            pipes_distance_to_first_support: vmt.issue['pipes_distance_to_first_support'],
                            pipes_proximity_to_each_other: vmt.issue['pipes_proximity_to_each_other'],
                            cables_selected: vmt.issue['cables_selected'],
                            cables_size: vmt.issue['cables_size'],
                            cables_bundles: vmt.issue['cables_bundles'],
                            cables_trays_type: vmt.issue['cables_trays_type'],
                            cables_trays_size: vmt.issue['cables_trays_size'],
                            cables_support_conditions: vmt.issue['cables_support_conditions'],
                            cables_distance_to_first_support: vmt.issue['cables_distance_to_first_support'],
                            cables_proximity_to_each_other: vmt.issue['cables_proximity_to_each_other'] !== undefined ? vmt.issue['cables_proximity_to_each_other'] : null,
                            ducts_selected: vmt.issue['ducts_selected'],
                            ducts_size: vmt.issue['ducts_size'],
                            ducts_manufacturer: vmt.issue['ducts_manufacturer'],
                            ducts_seal_details: vmt.issue['ducts_seal_details'],
                            ducts_support_conditions: vmt.issue['ducts_support_conditions'],
                            ducts_distance_to_first_support: vmt.issue['ducts_distance_to_first_support'],
                            ducts_proximity_to_each_other: vmt.issue['ducts_proximity_to_each_other'] !== undefined ? vmt.issue['ducts_proximity_to_each_other'] : null,
                            opening_size: vmt.issue['opening_size'],
                            opening_depth: vmt.issue['opening_depth'] !== undefined ? vmt.issue['opening_depth'] : null,
                            opening_preparation: vmt.issue['opening_preparation'],
                            opening_preparation_details: vmt.issue['opening_preparation_details'],
                            opening_preparation_adequate: vmt.issue['opening_preparation_adequate'],
                            opening_proximity_to_other_elements: vmt.issue['opening_proximity_to_other_elements'],
                            opening_space_adequate: vmt.issue['opening_space_adequate'],
                            work_required: vmt.issue['work_required'],
                            installation_date: vmt.issue['installation_date'],
                            installed_by: vmt.issue['installed_by'],
                            engineer_signature_image: vmt.issue['engineer_signature_image'],
                            audit_date: vmt.issue['audit_date'] !== undefined ? vmt.issue['audit_date'] : null,
                            audit_comments: vmt.issue['audit_comments'] !== undefined ? vmt.issue['audit_comments'] : null,
                            audited_by: vmt.issue['audited_by'] !== undefined ? vmt.issue['audited_by'] : null,
                            sign_off_signature_image: vmt.issue['sign_off_signature_image'] !== undefined ? vmt.issue['sign_off_signature_image'] : null,
                            fsr_materials: vmt.issue['fsr_materials'],
                            fsr_products: vmt.issue['fsr_products'] !== undefined ? vmt.issue['fsr_products'] : [],
                            fire_stopping_report_item_faults: vmt.issue['fire_stopping_report_item_faults'],
                            fire_stopping_report_item_images: vmt.issue['fire_stopping_report_item_images'],
                            user_id: vmt.$session.get('user_id'),
                            offline_images: vmt.issue['offline_images'],
                            offline_engineer_signature_image: vmt.issue['offline_engineer_signature_image'],
                            offline_sign_off_signature_image: vmt.issue['offline_sign_off_signature_image'] !== undefined ? vmt.issue['offline_sign_off_signature_image'] : null,
                        });
                    putRequest.onsuccess = function(event) {
                        vmt.submitSuccess({
                            success: true,
                            site_fire_stopping_report_item_id: putRequest.result,
                        })
                    }
                    putRequest.onerror = function(event) {
                        alert("Unable to add data ");
                    };
                })

            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'fire-stopping-report-view-item', params: {id: response.site_fire_stopping_report_item_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.issue)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.issue[field]) {
                    return this.$v.issue[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
            updateSitePlanComponent() {
                console.log('Site plan on-change');
                this.$refs.sitePlanComponent.updateDisplayedSitePlan();
            },
            updateMarker(marker) {
                console.log(marker);
                this.issue.site_plan_image_position_x = marker.x;
                this.issue.site_plan_image_position_y = marker.y;
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FSR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getFireRatings();
            this.getSubstrateTypes();
            this.getConstructionTypes();
            this.getThermalInsulations();
            this.getFsrFaults();
            this.getFsrMaterials();
            this.getFsrProducts();

            if (this.$route.name === 'fire-stopping-report-edit-item') {
                this.isEdit = true;
            }
            
            if (!this.isEdit) {
                this.getFireStoppingReport(true);
            } else {
                this.getIssue();
            }
        },
        computed: {
            sitePlanMarkerData() {
                if(!this.issue.site_plan_image_position_x || !this.issue.site_plan_image_position_y) {
                    return null;
                }

                return {
                    position_x: this.issue.site_plan_image_position_x,
                    position_y: this.issue.site_plan_image_position_y,
                    zoom: this.issue.site_plan_image_zoom_level !== undefined ? this.issue.site_plan_image_zoom_level : 1
                };
            },
            selectedSitePlanImg() {
                console.log('Selected Site Plan: ' + this.issue.site_fire_stopping_report_site_plan_id);
                if(!this.issue.site_fire_stopping_report_site_plan_id) {
                    return null;
                }

                var selectedSitePlan = this.sitePlans.find((sitePlan) => {
                    return sitePlan.site_fire_stopping_report_site_plan_id == this.issue.site_fire_stopping_report_site_plan_id;
                });

                console.log('Selected Site Plan: ' + JSON.stringify(selectedSitePlan));

                if(!selectedSitePlan) {
                    return null;
                }

                if(selectedSitePlan.offline_site_plan_image) {
                    return selectedSitePlan.offline_site_plan_image.data;
                }
                
                return selectedSitePlan.site_plan_image ? (this.cmsUrl + selectedSitePlan.site_plan_image) : null;
            },
            substrateNamesArray() {
                var values = [];
                this.fsrSubstrateTypes.forEach(option => {
                    values.push(option.fsr_substrate_type_name);
                });
                return values;
            },
            constructionTypeNamesArray() {
                var values = [];
                this.fsrConstructionTypes.forEach(option => {
                    values.push(option.fsr_construction_type_name);
                });
                return values;
            },
            preInstallationImages() {
                var imgs = [];
                this.issue.offline_images.forEach(item => {
                    if(item.is_pre_installation_img) {
                        imgs.push(item);
                    }
                });
                return imgs;
            },
            postInstallationImages() {
                var imgs = [];
                this.issue.offline_images.forEach(item => {
                    if(!item.is_pre_installation_img) {
                        imgs.push(item);
                    }
                });
                return imgs;
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    form {
        margin-bottom: 2rem;
    }

    [class*='-message'] {
        font-weight: 500;
    }

    .has-error {
        border: 1px solid #d33c40;
    }

    .error-message {
        color: #d33c40;
    }

    .success-message {
        color: #32a95d;
    }

    .form-control {
        background: #fff !important;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>